import { useTheme } from '@mui/material';
import { PieChartProps, PieValueType } from '@mui/x-charts';
import { useIntl } from 'react-intl';

import { AnnotationProgress } from '../../types/responseTypes';

interface UseDashboardOverallProgressProps {
  annotationProgressData: AnnotationProgress | null;
}

interface UseDashboardOverallProgressResults {
  annotationProgressPieSeriesData: PieValueType[];
  size: Pick<PieChartProps, 'width' | 'height'>;
}

export const useDashboardOverallProgress = ({
  annotationProgressData,
}: UseDashboardOverallProgressProps): UseDashboardOverallProgressResults => {
  const theme = useTheme();
  const { formatMessage } = useIntl();
  const annotationProgressPieSeriesData = [
    {
      id: 'pending',
      value: annotationProgressData?.pendingTaskCount ?? 0,
      label: formatMessage({ id: 'metrics.dashboard.overallProgress.pending.label' }),
      color: theme.palette.primary.light,
    },
    {
      id: 'completed',
      value: annotationProgressData?.completedTaskCount ?? 0,
      label: formatMessage({ id: 'metrics.dashboard.overallProgress.completed.label' }),
      color: theme.palette.primary.dark,
    },
  ];

  const size = {
    width: 400,
    height: 250,
  };
  return {
    annotationProgressPieSeriesData,
    size,
  };
};
